export function splitRoomString(
  roomString = '',
): {roomCount: number; paxCount: number; childCount: number; childAgeArray: number[]} {
  const roomStr = roomString.split('-');
  let roomCount = parseInt(roomStr[0], 10);
  let paxCount = 0;
  let childCount = 0;
  let childAgeArray = [];
  if (roomStr.length > 2) {
    paxCount = parseInt(roomStr[1], 10);
    childCount = parseInt(roomStr[2], 10);
    // childCount = parsedChildCount ? parseInt(roomStr[2].split('_')[0], 10) : parsedChildCount;
  }
  if (childCount > 0 && roomStr.length > 3) {
    childAgeArray = roomStr[3].split('_');
    childAgeArray = childAgeArray.map(item => parseInt(item, 10));
  }
  return {roomCount, paxCount, childCount, childAgeArray};
}
type RoomConfigResponse = {
  roomConfig?: Array<{
    adult: number | string;
    children: number | string;
    age1: number | string;
    age2: number | string;
    childArray: Array<{
      age?: number | string;
    }>;
  }>;
  adultCount?: number | string;
  childrenCount?: number | string;
  room?: number;
  childAgeArray: Array<number>;
};
export function getRoomConfig(roomString = ''): RoomConfigResponse {
  const arr = roomString.split('-');
  let paxObject = {};
  paxObject.room = parseInt(arr[0], 10);
  const roomConfig = [];
  let adultCount = 0;
  let childrenCount = 0;
  let childAgeArray = [];
  arr.slice(1).forEach(roomStr => {
    const childArray = [];
    const roomConfigArr = roomStr.split('_').map(item => parseInt(item, 10));
    const adult = roomConfigArr[0] || 0;
    const children = roomConfigArr[1] || 0;
    const age1 = roomConfigArr[2] || 0;
    const age2 = roomConfigArr[3] || 0;
    adultCount += adult;
    childrenCount += children;
    if (age1) {
      childArray.push({age: age1});
      childAgeArray.push(age1);
    }

    if (age2) {
      childArray.push({age: age2});
      childAgeArray.push(age2);
    }
    const roomObj = {
      adult,
      children,
      age1,
      age2,
      childArray,
    };
    roomConfig.push(roomObj);
  });
  paxObject.roomConfig = roomConfig;
  paxObject.adultCount = adultCount;
  paxObject.childrenCount = childrenCount;
  paxObject.childAgeArray = childAgeArray;
  return paxObject;
}

export function convertRoomStringToReadable(roomString) {
  const {roomCount, paxCount, childCount} = splitRoomString(roomString);
  const numberOfGuests = paxCount + childCount;
  return `${numberOfGuests} ${numberOfGuests === 1 ? 'Guest' : 'Guests'} in ${roomCount} ${
    roomCount === 1 ? 'Room' : 'Rooms'
  } `;
}

// expected output string 1-2-2-3_2
// 1 room 2 adults 2 children age 3 age 2
export function convertToRoomString({
  roomCount,
  paxCount,
  childCount,
  childAgeArray = [],
}: {
  roomCount: number;
  paxCount: number;
  childCount: number;
  childAgeArray?: Array<number>;
}) {
  let roomString = `${roomCount}-${paxCount}-${childCount}`;
  if (childAgeArray && childAgeArray.length > 0) {
    roomString += childAgeArray.map((item, index) => `${index === 0 ? '-' : '_'}${item}`).join('');
  }
  return roomString;
}

export const oldRoomStrValidator = (roomString = '1-1_0') => {
  // has to be fixed. It should convert the old roomstring to newer version
  // Some flaws in PAX string being sent from notifications are fixed in this method..
  const arr = roomString.split('-');
  const roomCount = parseInt(arr[0], 10);
  const slicedArr = arr.slice(1);
  if (roomCount === slicedArr.length) {
    return roomString;
  }
  if (roomCount < slicedArr.length) {
    let correctRoomStr = `${roomCount}-`;
    for (let i = 0; i < roomCount; i += 1) {
      correctRoomStr = correctRoomStr.concat(slicedArr[i]);
    }
    return correctRoomStr;
  }
  let correctRoomStr = `${slicedArr.length}-`;
  correctRoomStr = correctRoomStr.concat(slicedArr.join('-'));
  return correctRoomStr;
};

export function convertRoomStringFormat(roomString) {
  return roomString.substring(0, 3) + '-' + roomString.substring(4, roomString.length);
}

export const oldToNewRoomstring = (paxString = '') => {
  const {childrenCount, adultCount, room, childAgeArray} = getRoomConfig(paxString);
  const roomStr = convertToRoomString({
    roomCount: room,
    paxCount: adultCount,
    childCount: childrenCount,
    childAgeArray,
  });

  return roomStr;
};
